import { cn } from '@/lib/utils';
import { forwardRef } from 'react';
import type { ComponentType, SVGProps } from 'react';

interface IconProps extends SVGProps<SVGSVGElement> {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  className?: string;
}

export const Icon = forwardRef<SVGSVGElement, IconProps>(
  ({ icon: IconComponent, className, ...rest }, ref) => {
    const mergedClassName = cn('w-6 h-6 ', className);

    return <IconComponent className={mergedClassName} {...rest} />;
  }
);

Icon.displayName = 'Icon';
